export const handleTypeService = {
  success: {
    title: "Requisição feita com sucesso!",
    description: "Requisição feita com sucesso!",
    color: "#9fc54d",
  },

  copyMessage: {
  title: "Mensagem copiada com sucesso!",
  description: "Cole a mensagem no local onde foi feita a inclusão do novo texto.",
  color: "#9fc54d",
  },

  searchError: {
    title: "Erro ao efetuar a requisição!",
    description:
      "O número de registros retornados pela consulta excede o limite. Por favor, repita a consulta usando mais filtros e menos palavras chave.",
    color: "#ff6464",
  },

  error: {
    title: "Erro ao efetuar a requisição!",
    description: "Tente novamente mais tarde.",
    color: "#ff6464",
  },

  googleLoginNotRegistered: {
    title: "Acesso não permitido",
    description:
      "Este e-mail não está cadastrado no sistema. Solicite cadastro ao administrador.",
    color: "#ff6464",
  },

  googleLoginAccountDisabled: {
    title: "Conta desativada",
    description:
      "Sua conta está desativada. Entre em contato com o administrador do sistema.",
    color: "#ff6464",
  },

  oauthCallbackMissingTokens: {
    title: "Sessão não iniciada",
    description:
      "Não foi possível obter os tokens de acesso. Tente entrar novamente. Se persistir, verifique a configuração do ambiente (URL do front e OAuth).",
    color: "#ff6464",
  },

  copyError: {
    title: "Erro ao copiar URL!",
    description: "Tente novamente mais tarde.",
    color: "#ff6464",
  },

  copySuccess: {
    title: "URL copiada!",
    description: "",
    color: "#9fc54d",
  },

  postError: {
    title: "Erro ao agendar ato!",
    description: "Tente novamente mais tarde.",
    color: "#ff6464",
  },

  postMissingDescription: {
    title: "Erro ao agendar ato!",
    description:
      "Preencha o campo Descrição: não foi possível identificá-la no documento.",
    color: "#ff6464",
  },

  scheduleError: {
    title: "Erro ao buscar atos agendados!",
    description: "Tente novamente mais tarde.",
    color: "#ff6464",
  },

  fileInvalid: {
    title: "Erro ao carregar arquivo!",
    description: "O formato do arquivo deve ser em .docx.",
    color: "#ff6464",
  },

  postInvalid: {
    title: "Erro ao enviar agendamento!",
    description:
      "Todos os campos com * devem ser preenchidos, juntamente com o arquivo em formato .docx.",
    color: "#ff6464",
  },
  deletePublishedError: {
    title: "Erro ao excluir publicação!",
    description: "Tente novamente mais tarde.",
    color: "#ff6464",
  },
  selectionError: {
    title: "Erro ao processar texto selecionado!",
    description: "Tente novamente.",
    color: "#ff6464",
  },
  sameSelection:{
    title: "O texto selecionado é o mesmo que o anterior!",
    description: "Selecione algo diferente.",
    color: "#ff6464",
  }
};

export const getApiErrorToast = (status?: number, isSearch = false) => {
  if (isSearch && status === 503) {
    return handleTypeService.searchError;
  }

  switch (status) {
    case 400:
      return {
        title: "Requisição inválida",
        description: "Confira os dados informados e tente novamente.",
      };
    case 401:
      return {
        title: "Sessão expirada",
        description: "Entre novamente para continuar.",
      };
    case 403:
      return {
        title: "Acesso negado",
        description: "Você não tem permissão para realizar esta ação.",
      };
    case 404:
      return {
        title: "Registro não encontrado",
        description: "O recurso solicitado não existe ou foi removido.",
      };
    case 409:
      return {
        title: "Conflito na requisição",
        description: "Os dados foram alterados. Atualize a página e tente novamente.",
      };
    case 429:
      return {
        title: "Muitas requisições",
        description: "Aguarde alguns instantes e tente novamente.",
      };
    case 500:
    case 502:
    case 503:
      return {
        title: "Serviço indisponível",
        description: "Tente novamente mais tarde.",
      };
    default:
      return handleTypeService.error;
  }
};

export const ptLocale = {
  months: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],

  weekDays: [
    {
      name: "Domingo",
      short: "D",
      isWeekend: true,
    },
    {
      name: "Segunda-feira",
      short: "S",
    },
    {
      name: "Terça-feira",
      short: "T",
    },
    {
      name: "Quarta-feira",
      short: "Q",
    },
    {
      name: "Quinta-feira",
      short: "Q",
    },
    {
      name: "Sexta-feira",
      short: "S",
    },
    {
      name: "Sábado",
      short: "S",
      isWeekend: true,
    },
  ],

  weekStartingIndex: 0,

  getToday(gregorainTodayObject: any) {
    return gregorainTodayObject;
  },

  toNativeDate(date: any) {
    return new Date(date.year, date.month - 1, date.day);
  },

  getMonthLength(date: any) {
    return new Date(date.year, date.month, 0).getDate();
  },

  transformDigit(digit: any) {
    return digit;
  },

  nextMonth: "Próximo Mês",
  previousMonth: "Mês Anterior",
  openMonthSelector: "Abrir Selecionador de Mês",
  openYearSelector: "Abrir Selecionador de Ano",
  closeMonthSelector: "Fechar Selecionador de Mês",
  closeYearSelector: "Fechar Selecionador de Ano",
  defaultPlaceholder: "Selecionar...",

  from: "de",
  to: "até",

  digitSeparator: ",",

  yearLetterSkip: 0,

  isRtl: false,
};

export const tutorialStyles = {
  options: {
      zIndex: 10000,
      primaryColor: '#2f5141',
      textColor: '#333',
      arrowColor: '#277618',
      backgroundColor: '#fff',
      overlayColor: 'rgba(0, 0, 0, 0.5)',
  },
  buttonNext: {
      backgroundColor: '#2f5141',
  },
  buttonBack: {
      color: '#277618',
  },
  buttonClose: {
      display: 'none',
  },
  tooltip: {
      borderRadius: '4px',
  },
};